import React, {useContext, useRef, useEffect, useState} from 'react';
import Flatpickr from 'react-flatpickr';
import {German} from 'flatpickr/dist/l10n/de.js';
import {Italian} from 'flatpickr/dist/l10n/it.js';
import {AppContext} from '../../contexts/AppContext';
import useIsMobile from '../../hooks/useIsMobile';
import {translate} from '../../helpers/base';

const DatesTab = ({onChange, onNext, onClear, selectedDates}) => {

    const {setIsBookingBoxOverlayVisible, locale} = useContext(AppContext);
    const flatpickrRef = useRef(null);
    const isMobile = useIsMobile(768);
    const [showApplyButton, setShowApplyButton] = useState(false);

    const checkinDate = selectedDates[0];
    const checkoutDate = selectedDates[1];

    const handleDateChange = (dates) => {

        // force end date to be at least 1 day after start date
        if (dates.length === 2) {
            let startDate = dates[0];
            let endDate = dates[1];
            let diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
            if (diffInDays < 1) {
                let adjustedEndDate = new Date(startDate);
                adjustedEndDate.setDate(startDate.getDate() + 1);
                flatpickrRef.current?.flatpickr.setDate([startDate, adjustedEndDate], true);
                dates[1] = adjustedEndDate;
            }
            // hide apply button if dates are selected
            setShowApplyButton(false);
        }
        onChange([...dates]);
    };

    const handleClearDates = () => {
        onChange([]);
        flatpickrRef.current?.flatpickr.clear();
        setShowApplyButton(true);
    };

    const handleCloseOverlay = () => {
        if(flatpickrRef.current?.flatpickr.selectedDates.length < 2) {
            onClear();
        }
        setIsBookingBoxOverlayVisible(false);
        setShowApplyButton(false);
    }

    const now = new Date();
    const minDate = now.setHours(0, 0, 0, 0);

    const dpOptions = {
        mode: 'range',
        minDate: minDate,
        defaultDate: [checkinDate, checkoutDate],
        showMonths: isMobile ? 1 : 2,
        dateFormat: 'd.m.Y',
        allowInput: false,
        inline: true,
        monthSelectorType: 'static',
        onChange: handleDateChange,
    };

    if(locale === 'de') {
        dpOptions.locale = German;
    } else if(locale === 'it') {
        dpOptions.locale = Italian;
    }

    useEffect(() => {
        const container = flatpickrRef.current?.flatpickr.calendarContainer;
        if (container) {
            if (isMobile) {
                container.classList.remove('multiMonth');
            } else {
                container.classList.add('multiMonth');
            }
        }
    }, [isMobile]);

    return (
        <div className="content-tab content-tab-dates active">
            <div className="page--overlay--header area--text">
                <span className="lead">{translate('booking-box.dates.header')}</span>
                <label className="page--overlay--close" onClick={handleCloseOverlay}></label>
            </div>
            <div className="page--overlay--content">
                <div className="booking-box--overlay--date">
                    <Flatpickr ref={flatpickrRef} options={dpOptions}/>
                </div>
            </div>
            <div className="page--overlay--bottom-btns">
                {showApplyButton ? (
                    <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={handleCloseOverlay}
                    >
                        {translate('booking-box.dates.apply')}
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-outline btn-sm"
                        onClick={handleClearDates}
                        disabled={!checkinDate && !checkoutDate}
                    >
                        {translate('booking-box.dates.reset')}
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-primary btn-switch btn-sm"
                    onClick={onNext}
                    disabled={!checkinDate || !checkoutDate}
                >
                    {translate('booking-box.dates.next')}
                </button>
            </div>
        </div>
    );
};

export default DatesTab;